<template>
    <div class="pagebox">
        <el-form :model="projectInfo" ref="form" label-width="200px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="学校名称:">
                        {{ projectInfo.school&&projectInfo.school.name }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="申报团队:">
                        {{ projectInfo.team&&projectInfo.team.name }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目名称:">
                        {{ projectInfo.name }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="申报奖项:">
                        <span v-show="projectInfo.isdeclare==null">未选择</span>
                        <span v-show="projectInfo.isdeclare==0">常规奖项目</span>
                        <span v-show="projectInfo.isdeclare==1">品牌奖项目</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="projectInfo.isdeclare==1">
                <el-col :span="24">
                    <el-form-item label="历年成果:">
                        <table class="custom-table">
                            <tr scope="col">
                                <td>首次参赛时间</td>
                                <td colspan="2">
                                    {{ projectInfo.declarecontent_data.prizetime }}
                                </td>
                            </tr>
                            <tr>
                                <td>首次参赛名称</td>
                                <td colspan="2">
                                    {{ projectInfo.declarecontent_data.prizename }}
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="3">历年成果</td>
                                <td>
                                    {{ projectInfo.declarecontent_data.prizeyear1 }}年
                                </td>
                                <td>
                                    {{ projectInfo.declarecontent_data.achievement1 }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ projectInfo.declarecontent_data.prizeyear2 }}年
                                </td>
                                <td>
                                    {{ projectInfo.declarecontent_data.achievement2 }}、
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ projectInfo.declarecontent_data.prizeyear3 }}年
                                </td>
                                <td>
                                    {{ projectInfo.declarecontent_data.achievement3 }}
                                </td>
                            </tr>
                            <tr>
                                <td>本届创新点</td>
                                <td colspan="2">
                                    {{ projectInfo.declarecontent_data.prizes }}
                                </td>
                            </tr>
                        </table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目内容:">
                        {{ projectInfo.project_type_texts }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="项目负责人:">
                        {{ projectInfo.dutyperson }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目负责人联系方式:">
                        {{ projectInfo.dutypersonphone }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="项目负责人专业:">
                        {{ projectInfo.dutypersonmajor }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="指导老师:">
                        <el-table :data="projectTeacherList" border style="width: 100%">
                            <el-table-column label="姓名" align="center" prop="name" />
                            <el-table-column label="联系方式" align="center" prop="phone" />
                            <el-table-column label="职务" align="center" prop="position" />
                            <el-table-column label="专业" align="center" prop="teachermajor" />
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="项目团队成员:">
                        <el-table :data="projectMemberList" border style="width: 100%">
                            <el-table-column label="成员姓名" align="center" prop="name" />
                            <el-table-column label="联系方式" align="center" prop="phone" />
                            <el-table-column label="专业" align="center" prop="major" />
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="通讯地址:">
                        {{ projectInfo.address }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="活动时间:">
                        {{ projectInfo.activitytime }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="活动地点:">
                        {{ projectInfo.activityaddress }}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="活动对象:">
                        {{ projectInfo.activityobject }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="项目简介:">
                        <div v-html="projectInfo.introduce" class="rich-text"></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="项目特色:">
                        <div v-html="projectInfo.innovate" class="rich-text"></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="推进步骤:">
                        <div v-html="projectInfo.step" class="rich-text"></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="项目风险及对应措施:">
                        <div v-html="projectInfo.risk" class="rich-text"></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="预期达到的目标:">
                        <div v-html="projectInfo.target" class="rich-text"></div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="项目预算:">
                        <el-table :data="projectCheckList" border style="width: 100%">
                            <el-table-column label="支出科目" align="center" prop="paysubject" />
                            <el-table-column label="总金额" align="center" prop="totalprice" />
                            <el-table-column label="单价" align="center" prop="unitprice" />
                            <el-table-column label="数量" align="center" prop="amount" />
                            <el-table-column label="备注" align="center" prop="remarks" />
                        </el-table>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="总预算:">
                        {{ projectInfo.allMoney }}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="type==1">
                <el-col :span="24">
                    <el-form-item label="审核">
                        <el-radio v-model="radio" label="1">通过</el-radio>
                        <el-radio v-model="radio" label="2">退回(还剩{{3-(projectInfo.editnum+1)}}次)</el-radio>
                    </el-form-item>
                </el-col>
                <el-col v-if="radio==2">
                    <el-form-item label="选择意见">
                        <el-button type="primary" @click="dialogVisible = true">选择意见</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="退回原因" v-if="radio==2">
                        <el-input v-model="reason" type="textarea" :rows="4" placeholder="请输入退回原因"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="type==1" class="btn-row">
                <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" @click="submitForm">确认</el-button>
                     <el-button @click="fanhui">返回</el-button>
                </el-col>
            </el-row>
        </el-form>

        <!-- 意见选择弹窗 -->
        <el-dialog title="选择意见" :visible.sync="dialogVisible" width="50%">
            <el-checkbox-group v-model="selectedOpinions">
                <div v-for="(item, index) in yijianlist" :key="index" class="opinion-item">
                    <el-checkbox :label="item.content">{{ item.content }}</el-checkbox>
                </div>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmOpinions">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getProjectFind,getProjectMember,getProjectTeacher,getProjectBudgetList,updateAdminProject,yijian } from "@/api/signUp";
    export default {
        data() {
            return {
                project_id: '',
                projectInfo:{},//项目详情
                projectMemberList:[],//项目成员
                projectTeacherList:[],//项目老师
                projectCheckList:[],//项目预算
                radio: '1',
                type:0,
                reason:'',
                yijianlist:[],//意见列表
                dialogVisible: false,
                selectedOpinions: []
            }
        },
        mounted() {
            this.project_id = this.$route.query.project_id;
            this.type = this.$route.query.type;
            this.getProjectInfo();
			this.getyijian()
        },
        methods: {
            getProjectInfo(){
                //获得项目详情
                getProjectFind({
                    project_id: this.project_id
                }).then((res) => {
                    this.projectInfo = res.data.data;
                    this.projectInfo.allMoney = this.projectInfo.projectbubget.reduce((total, product) => total + Number(product.totalprice), 0).toFixed(2)
                });
                //获得项目成员
                getProjectMember({
                    project_id: this.project_id
                }).then((res) => {
                    this.projectMemberList = res.data.data;
                })
                //项目老师
                getProjectTeacher({
                    project_id: this.project_id
                }).then((res) => {
                    this.projectTeacherList = res.data.data;
                })
                getProjectBudgetList({
                    project_id: this.project_id
                }).then((res) => {
                    this.projectCheckList = res.data.data;
                })
            },
			//加载意见
			getyijian(){
				yijian().then(res=>{
                    console.log(res)
					this.yijianlist = res.data.data
				})
			},
            // 确认选择意见
            confirmOpinions() {
                if (this.selectedOpinions.length > 0) {
                    // 如果reason已有内容，则换行追加；否则直接赋值
                    const newOpinions = this.selectedOpinions.join('\n');
                    this.reason = this.reason ? this.reason + '\n' + newOpinions : newOpinions;
                }
                this.dialogVisible = false;
                this.selectedOpinions = []; // 清空选择
            },
            //审核
            submitForm(){
                console.log(JSON.parse(localStorage.getItem('userInfo')))
                updateAdminProject({
                    project_id: this.project_id,//项目id
                    admin_id: JSON.parse(localStorage.getItem('userInfo')).id,//管理员id
                    operation: this.radio==1?'同意':'拒绝',//审核状态
                    reason: this.reason//拒绝理由
                }).then(res=>{
                    if(res.data.code==1){
                        this.$message.success('审核成功');
                        this.$router.push({
                            name: "rich"
                        });
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
            },
            //返回
            fanhui(){
                this.$router.go(-1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pagebox{
        padding: 20px;
        
        ::v-deep .el-form-item__label {
            font-weight: bold;
            font-size: 16px;
            color: #303133;
        }

        ::v-deep .el-table th {
            font-weight: bold;
            background-color: #f5f7fa;
            color: #303133;
        }

        .custom-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
            color: #606266;
            
            tr {
                border: 1px solid #EBEEF5;
            }
            td {
                border: 1px solid #EBEEF5;
                padding: 12px;
                text-align: left;
            }
            tr:hover {
                background-color: #F5F7FA;
            }
        }
        
        .rich-text {
            font-size: 14px;
            line-height: 1.5;
            color: #606266;
            ::v-deep img {
                max-width: 100%;
            }
        }

        .btn-row {
            margin-top: 20px;
        }

        .opinion-item {
            margin-bottom: 10px;
        }
    }
</style>